import { render, staticRenderFns } from "./OfficeScene.vue?vue&type=template&id=34752e07&scoped=true&lang=pug&"
import script from "./OfficeScene.vue?vue&type=script&lang=js&"
export * from "./OfficeScene.vue?vue&type=script&lang=js&"
import style0 from "./OfficeScene.vue?vue&type=style&index=0&id=34752e07&lang=scss&scoped=true&"
import style1 from "./OfficeScene.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34752e07",
  null
  
)

export default component.exports